import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-link-erply',
  templateUrl: './link-erply.component.html',
  styleUrls: ['./link-erply.component.scss']
})
export class LinkErplyComponent {

  @Input() partner;
  @Input() selectedPOS;
  @Input() modal;

  @Output() status = new EventEmitter();

  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public win;

  public configurationSaved: boolean = false;
  public username: string = null;
  public password: string = null;
  public apiKey: string = null;
  public clientID: string = null;
  public clientCode: string = null;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.busy = false;
  }

  SaveSettings() {
    this.posIntegrationService
      .savePOSConnection(this.partner.PartnerID, {
        PartnerID: this.partner.PartnerID,
        Username: this.username,
        Password: this.password,
        POSID: 21,
        ClientCode: this.clientID,
      })
      .subscribe((x) => {
        if (this.modal !== undefined) this.modal.dismiss('Cross click');

      });
  }

}
